import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=7bc8e83c&scoped=true"
import script from "./Empty.vue?vue&type=script&lang=ts"
export * from "./Empty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc8e83c",
  null
  
)

export default component.exports